// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"work"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 7.5H21V20.5H3V7.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.5 7.5V3.5H8.5V7.5M3 7.5H21V20.5H3V7.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WorkIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'work',
    ref,
    icon: element,
  },
));

WorkIcon.displayName = 'WorkIcon';

export default WorkIcon;
